//OurPhilosophy.js
import React from 'react';
import './OurPhilosophy.css';

const OurPhilosophy = () => {
  return (
    <section className="philosophy-section">
      <div className="philosophy-content">
        <div className="philosophy-header">
          <h2>Our philosophy</h2>
          <p>
            At Cognitva, we believe AI adoption fails not because models are weak - but because <strong>regulated industries lack the infrastructure to deploy AI safely, repeatedly, and at scale.</strong>
            We are building <strong>Responsible-AI productization infrastructure</strong>, not point solutions.
            Our platform is designed for environments where <strong>explainability, compliance, and legacy coexistence are non-negotiable</strong>- healthcare systems, industrial plants, and other high-stakes enterprises where most AI remains stuck at proof-of-concept.
            Cognitva brings together:
            <strong>Ideonix™ </strong> - our Responsible-AI Productization Engine
            <strong>Cognitva WEAVE™ -</strong> our governed, cross-industry intelligence core.
            Together, they turn AI from experiments into <strong>audit-ready, production-grade systems</strong>
          </p>
        </div>

        <div className="vision-mission-container">
          <div className="philosophy-image">
            <img src="/images/imagePlaceholder.svg" alt="Cognitiva Logo" />
          </div>
          <div className="vision-mission-text">
            <div className="card">
              <h3>- VISION</h3>
              <p>
                To become the reference AI Productization Operating System for regulated industries.
              </p>
              <p className="small-text">
                Cognitva envisions a future where enterprises can safely deploy AI across healthcare, manufacturing, and regulated domains - using a unified intelligence foundation that is explainable, compliant, and reusable by design.
              </p>
            </div>
            <div className="card">
              <h3>- MISSION</h3>
              <p>
                To move AI adoption in regulated industries from pilots to production.
              </p>
              <p className="small-text">
                Through Ideonix™, we enable enterprises to productize AI using modular, explainable, and compliance-ready building blocks.
              </p>
              <p className="small-text">
                Through Cognitva WEAVE™, we deliver the domain intelligence, governance layers, and reasoning systems required for real-world deployment. We start where AI adoption is hardest - Healthcare - prove scale in Manufacturing, and expand into adjacent regulated sectors through reusable domain and compliance packs.
              </p>
              <p className='small-text'>
                Starting with legal and healthcare, we aim to democratize access to domain-specific AI across sectors - through modular architecture, enterprise-grade security, and seamless human-AI collaboration
              </p>
            </div>
          </div>
        </div>

        <div className="philosophy-divider"></div>
      </div>
    </section>
  );
};

export default OurPhilosophy;